// @ts-nocheck
/**
 * BottomNav — sticky mobile navigation bar
 * Visible only on screens ≤ 640px via CSS (.mobile-bottom-nav).
 * Shows active page indicator using current route.
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const TABS = [
  { path: '/',              icon: '🌍', label: 'Overview'  },
  { path: '/myclimate',     icon: '🌱', label: 'MyClimate' },
  { path: '/businessnexus', icon: '🏢', label: 'Business'  },
  { path: '/civicpulse',    icon: '🏛️', label: 'Civic'     },
];

const BottomNav: React.FC = () => {
  const navigate        = useNavigate();
  const { pathname }    = useLocation();

  return (
    <nav className="mobile-bottom-nav" role="navigation" aria-label="Main navigation">
      {TABS.map(t => {
        const isActive = pathname === t.path;
        return (
          <button
            key={t.path}
            className={`mobile-nav-btn${isActive ? ' active' : ''}`}
            onClick={() => navigate(t.path)}
            aria-label={t.label}
            aria-current={isActive ? 'page' : undefined}
          >
            <span className="mobile-nav-icon">{t.icon}</span>
            <span className="mobile-nav-label">{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
